export default {
  phases: [
    {
      actions: [
        'resort',
        'responsibility',
        'participation',
        'goals',
        'types',
        'management',
      ],
      color: '#2D2E85',
      key: 'planning',
      personas: [1, 2, 3, 4, 5, 6, 7],
      principles: [2, 4, 5, 8, 9],
      wrap: false,
    },
    {
      actions: ['privacy', 'confidential', 'copyright', 'global'],
      color: '#68B8C3',
      key: 'management',
      personas: [4, 5, 6, 7],
      principles: [1, 4],
      wrap: false,
    },
    {
      actions: ['supplier', 'debiasing', 'explainability', 'design', 'energy'],
      color: '#4E89CD',
      key: 'development',
      personas: [4, 6],
      principles: [1, 3, 4, 6],
      wrap: true,
    },
    {
      actions: [
        'pre-deployment',
        'pilot',
        'training',
        'accessibility',
        'inclusivity',
        'awareness',
        'knowledge',
      ],
      color: '#95BBAF',
      key: 'implementation',
      personas: [1, 2, 3, 4, 5, 6, 7],
      principles: [2, 7, 8, 10],
      wrap: true,
    },
    {
      actions: ['tracking', 'watch', 'updates'],
      color: '#365C85',
      key: 'maintenance',
      personas: [4, 5, 6],
      principles: [3, 4],
      wrap: true,
    },
  ],
} as {
  phases: Phase[]
}
